/* mm-vollbild.js — verhindert, dass Videos im TikTok-Browser das Bild kapern.
 *
 * 23.08.2026, Mert: "wenn man von TikTok aus auf die Seite drueckt, dann spielt
 * automatisch die Videos ab und es kommt zum Bildschirm. Also man kann nicht
 * raus da. Wenn man das rausmacht, wenn man mit dem Finger wegwischt, kommt das
 * eine Sekunde danach noch mal. Das wird dann so vergroessert ... Das haengt.
 * Es passiert nur ueber TikTok."
 *
 * WAS DA PASSIERT: Der eingebaute Browser von TikTok (eine Bytedance-WebView)
 * schiebt ein startendes Video von sich aus ins Vollbild - auch wenn
 * `playsinline` gesetzt ist. Auf der Startseite laufen aber mehrere Videos von
 * allein: das Hero-Video und die vier Story-Vorschauen, die alle paar Sekunden
 * weiterschalten. Jeder dieser Starts reisst das Bild erneut auf. Wischt man es
 * weg, faengt der naechste Start eine Sekunde spaeter wieder an - deshalb wirkt
 * es, als haenge die Seite.
 *
 * DER SAUBERE WEG ist nicht, gegen das Vollbild anzukaempfen, sondern den
 * Ausloeser wegzunehmen: In solchen App-Browsern laeuft **kein Video von
 * selbst**. Es bleibt beim Standbild; wer wirklich abspielen will, tippt selbst.
 * Ausserhalb dieser Browser aendert sich nichts.
 *
 * Zusaetzlich, als zweite Sicherung:
 *   - jedes <video> bekommt alle Merkmale, die WebViews vom Vollbild abhalten
 *     (playsinline, webkit-playsinline, x5-playsinline, kein Bild-in-Bild),
 *   - faehrt trotzdem eines ins Vollbild, wird es sofort wieder verlassen.
 */
(function () {
  'use strict';

  /* Bytedance/TikTok in allen Schreibweisen, dazu die ueblichen anderen
     App-Browser, die sich genauso verhalten. */
  var APP_BROWSER = /BytedanceWebview|Bytedance|musical_ly|TikTok|aweme|trill|Instagram|FBAN|FBAV|Snapchat|Line\/|MicroMessenger/i;

  var imApp = APP_BROWSER.test(navigator.userAgent || '');

  /* Andere Bausteine fragen diese Fahne ab, bevor sie ein Video starten. */
  window.mmKeinAutoVideo = imApp;

  function haerten(v) {
    if (!v || v.dataset.mmVoll) return;
    v.dataset.mmVoll = '1';
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('x5-playsinline', '');
    v.setAttribute('x5-video-player-type', 'h5');
    v.setAttribute('disablepictureinpicture', '');
    v.setAttribute('controlslist', 'nodownload noplaybackrate');

    /* Kommt es trotzdem ins Vollbild: sofort wieder heraus. */
    v.addEventListener('webkitbeginfullscreen', function () {
      try {
        if (v.webkitExitFullscreen) v.webkitExitFullscreen();
        else if (document.exitFullscreen) document.exitFullscreen();
      } catch (e) {}
    });

    if (imApp) {
      /* Im App-Browser laeuft nichts von selbst - auch dann nicht, wenn ein
         anderer Baustein `play()` ruft, bevor er die Fahne prueft. */
      v.removeAttribute('autoplay');
      v.autoplay = false;
      v.addEventListener('play', function (e) {
        if (v.dataset.mmGewollt === '1') return;   /* der Nutzer hat getippt */
        v.pause();
        try { v.currentTime = v.currentTime; } catch (err) {}
      });
      /* Ein echter Fingertipp auf das Video gilt als gewollt. */
      v.addEventListener('pointerup', function () { v.dataset.mmGewollt = '1'; });
      v.addEventListener('click', function () { v.dataset.mmGewollt = '1'; });
    }
  }

  function alle() {
    var v = document.querySelectorAll('video');
    for (var i = 0; i < v.length; i++) haerten(v[i]);
  }

  document.addEventListener('fullscreenchange', function () {
    var e = document.fullscreenElement;
    if (e && e.tagName === 'VIDEO' && e.dataset.mmVoll && document.exitFullscreen) {
      try { document.exitFullscreen(); } catch (err) {}
    }
  });

  alle();
  if (window.MutationObserver) {
    new MutationObserver(alle).observe(document.documentElement,
      { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  }
  window.addEventListener('load', alle);
})();
